import script from "./goRinSyo0017.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0017.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0017.vue?vue&type=style&index=0&id=366e707f&lang=scss"

const __exports__ = script;

export default __exports__